import { ReactComponent as BackIcon } from '@paradigm/icons/src/mailru/navigation/arrow_list_next.svg';
import classNames from 'clsx';
import { ReactComponent as IconClose } from 'img/icons/close_s__2.svg';
import React, { memo } from 'react';
import { IInputFile } from 'reactApp/modules/uploadList/uploadList.model';
import { Hint } from 'reactApp/ui/Hint/Hint';

import styles from './Problems.css';

interface ICloseProps {
    file: IInputFile;
    onClose: () => void;
}

interface IArrowsProps {
    fileIndex: number;
    fileLength: number;
    prevActive: boolean;
    nextActive: boolean;
    switchWarning: (params: { back: boolean; highlightFile: boolean }) => void;
}

const iconSize = {
    width: 16,
    height: 16,
};

export const CloseIcon = memo(({ file, onClose }: ICloseProps) => {
    if (!file) {
        return null;
    }

    return (
        <div className={styles.close} onClick={onClose}>
            <Hint text="Закрыть ошибку">
                <IconClose {...iconSize} />
            </Hint>
        </div>
    );
});

export const Arrows = memo(({ fileIndex, fileLength, prevActive, nextActive, switchWarning }: IArrowsProps) => {
    const nextWarning = () => {
        switchWarning({ back: false, highlightFile: true });
    };

    const prevWarning = () => {
        switchWarning({ back: true, highlightFile: true });
    };

    return (
        <div className={styles.arrows}>
            <div
                className={classNames({
                    [styles.arrow]: true,
                    [styles.prevIcon]: true,
                    [styles.active]: prevActive,
                })}
                onClick={prevWarning}
            >
                <BackIcon {...iconSize} />
            </div>
            <div className={styles.counter}>
                {fileIndex + 1} / {fileLength}
            </div>
            <div className={classNames({ [styles.arrow]: true, [styles.active]: nextActive })} onClick={nextWarning}>
                <BackIcon {...iconSize} />
            </div>
        </div>
    );
});
